import { type User } from 'firebase/auth';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import type { PostHog as PostHogClient } from 'posthog-js/react';
import { useEffect, type ReactNode } from 'react';

declare global {
  interface Window {
    getCkyConsent?: () => { categories: Record<string, boolean> };
    revisitCkyConsent?: () => void;
  }
}

export function identifyUser(user: User) {
  if (posthog.has_opted_in_capturing()) {
    posthog.identify(user.uid);
  }
}

function handleCookieConsent(consent: boolean) {
  if (consent) {
    posthog.opt_in_capturing();
  } else {
    posthog.opt_out_capturing();
  }
}

export const PostHog = (props: { children: ReactNode; client: PostHogClient }) => {
  useEffect(() => {
    const handleConsentUpdate = () => {
      const consent = window.getCkyConsent?.();
      if (consent) {
        const analyticsConsent = consent.categories?.analytics ?? false;
        handleCookieConsent(analyticsConsent);
      }
    };

    handleConsentUpdate();

    document.addEventListener('cookieyes_consent_update', handleConsentUpdate);
    return () => {
      document.removeEventListener('cookieyes_consent_update', handleConsentUpdate);
    };
  }, []);

  const apiKey = process.env.POSTHOG_KEY;
  if (!apiKey) {
    return props.children;
  }

  return <PostHogProvider client={props.client}>{props.children}</PostHogProvider>;
};
